export const UserStatusesEnum = {
    ACTIVATED: 'activated',
    DEACTIVATED: 'deactivated',
}
